import constants from "../constants";

const { UPDATE_NOTIFICATIONS, REMOVE_NOTIFICATIONS, UPDATE_BADGE_NOTIFICATIONS } = constants;

const initialState = {
  notifications: {},
  badgeNumber: 0,
};
export default (state = initialState, action) => {
  if (!action) return state;
  const { type, data, isMainUser } = action;

  switch (type) {
    case UPDATE_NOTIFICATIONS: {
      if (!isMainUser) {
        const notificationsArray = Object.values(data || {});
        return {
          ...state,
          notifications: { ...action.data },
          badgeNumber: notificationsArray.length,
        };
      }

      const notificationsArray = Object.values(data || {});

      // let unreadAppartments = 0;
      let badgeNumber = 0;

      const grouped = notificationsArray.reduce((acc, notif) => {
        const { apartmentId, uid, readByMainUser, createdAt } = notif;

        if (!acc[apartmentId]) {
          acc[apartmentId] = {
            apartmentName: notif.apartmentName,
            projectId: notif.projectId,
            projectName: notif.projectName,
            apartmentId,
            notifications: {},
            unreadNumber: 0,
            unreadByClientNumber: 0,
            totalNumber: 0,
            lastCreatedAt: createdAt, // initialize with first notification
          };
        }

        acc[apartmentId].notifications[uid] = notif;

        // Update lastCreatedAt if this notification is newer
        if (createdAt > acc[apartmentId].lastCreatedAt) {
          acc[apartmentId].lastCreatedAt = createdAt;
        }

        if (!readByMainUser) {
          acc[apartmentId].unreadNumber += 1;
          badgeNumber += 1;
        }

        if (!notif.read) {
          acc[apartmentId].unreadByClientNumber += 1;
        }

        acc[apartmentId].totalNumber += 1;
        return acc;
      }, {});

      return {
        ...state,
        notificationsByApartment: grouped,
        badgeNumber,
        totalNumber: notificationsArray.length,
      };
    }
    case REMOVE_NOTIFICATIONS:
      return { badgeNumber: 0, notifications: {} };
    case UPDATE_BADGE_NOTIFICATIONS:
      return { ...state, badgeNumber: data };
    default:
      return state;
  }
};
